import {Component, Injector} from '@angular/core';
import {PressDownloadState, Store as PressDownloadStore} from './state/store';
import {PressDownload} from './state/model';
import {PressDownloadService as PressDownloadService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {PressDownloadQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class PressDownloadDetailComponent extends EntityDetailComponent<PressDownload, PressDownloadState, PressDownloadStore> {

  constructor(
    public injector: Injector,
    service: PressDownloadService,
    protected query: PressDownloadQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
